import { render } from "./DocConnectView.vue?vue&type=template&id=a15f02d8"
import script from "./DocConnectView.vue?vue&type=script&lang=js"
export * from "./DocConnectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__